module.exports = __webpack_public_path__ + "fonts/effect-genetic-recode-barrier-2406a5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/icons/effect-genetic-recode-barrier.svg
// module id = 758
// module chunks = 0